import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOptions } from 'src/app/shared/models/dto';

@Component({
  selector: 'app-dialog-info',
  templateUrl: './dialog-info.component.html',
  styleUrls: ['./dialog-info.component.scss']
})
export class DialogInfoComponent {

  public result: Promise<any>;
  public resolve: any;
  public reject: any;
  public isResolved: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogOptions) {
    this.result = new Promise<any>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  btnOkClick() {
    this.isResolved = true;
    this.resolve();
  }

  isNascondiAnnulla() {
    if (this.data.isErrore || !this.data.isShowCancelButton) {
      return true;
    }

    return false;
  }
}